import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-dialog-viewer',
    templateUrl: './dialog-viewer.component.html',
    styleUrls: ['./dialog-viewer.component.scss'],
    standalone: false
})
export class DialogViewerComponent implements OnInit {

  @Input() model;
  @Input() languages;
  @Input() characters;
  @Input() defaultLang;
  @Input() editMode = false;
  @Input() htmlMode = true;

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  getCharacterMoodUrl(characterId, moodId){
    if(this.characters){
      for(let character of this.characters){
        if(character.id == characterId && character.moods){
          for(let mood of character.moods){
            if(mood.id == moodId){
              return mood.fileURL;
            }
          }
        }
      }
    }
    return null;
  }

}
